import React, { useId } from 'react'
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    CartesianGrid
} from 'recharts'
import styles from "../charts.module.css"
import { formatValueWithUnit } from '../chartUtils'

const ChartLine = ({ data, color = "#7B61FF", unit = "" }) => {
    const shadowId = useId().replace(/:/g, "")
    const allDataZero = data.every(item => item.value === 0)

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const item = payload[0].payload

            return (
                <div className={styles.tooltip}>
                    <p>
                        <span className={styles.tooltipLabel}>{item.name}</span>
                        <span className={styles.tooltipValue}>{item.formattedValue || formatValueWithUnit(item.value, unit)}</span>
                    </p>
                </div>
            )
        }
        return null
    }

    return allDataZero ? (
        <div className={styles.emptyChartMessage}>
            <p>Nenhum dado para exibir</p>
        </div>
    ) : (
        <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data} margin={{ top: 14, right: 16, left: 8, bottom: 8 }}>
                <defs>
                    <filter id={shadowId} x="-20%" y="-20%" width="140%" height="140%">
                        <feDropShadow dx="0" dy="4" stdDeviation="4" floodColor={color} floodOpacity="0.25" />
                    </filter>
                </defs>
                <CartesianGrid strokeDasharray="4 8" stroke="var(--border-subtle-color)" vertical={false} />
                <XAxis
                    dataKey="name"
                    axisLine={false}
                    tickLine={false}
                    minTickGap={22}
                    tick={{ fill: "var(--text-secondary)", fontSize: 12, fontWeight: 600 }}
                />
                <YAxis
                    width={34}
                    axisLine={false}
                    tickLine={false}
                    tick={{ fill: "var(--text-secondary)", fontSize: 11, fontWeight: 600 }}
                    tickFormatter={(value) => new Intl.NumberFormat("pt-BR", {
                        notation: Math.abs(value) >= 10000 ? "compact" : "standard",
                        maximumFractionDigits: 1
                    }).format(value)}
                />
                <Tooltip content={<CustomTooltip />} offset={12} wrapperStyle={{ outline: "none" }} />
                <Line
                    type="monotone"
                    dataKey="value"
                    stroke={color}
                    strokeWidth={3}
                    filter={`url(#${shadowId})`}
                    dot={{ r: 4, strokeWidth: 2, fill: "var(--surface-card)", stroke: color }}
                    activeDot={{ r: 7, strokeWidth: 3, fill: color, stroke: "var(--surface-card)" }}
                />
            </LineChart>
        </ResponsiveContainer>
    )
}

export default ChartLine
